"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssessmentReviewStats = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
const userAssessmentReview_1 = require("../core/userAssessmentReview");
exports.getAssessmentReviewStats = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/consolidated-assessments/:entityId/reviews",
    alias: "getAssessmentReviewStats",
    parameters: [
        {
            type: "Path",
            name: "entityId",
            schema: zod_1.z.string(),
        },
    ],
    response: userAssessmentReview_1.userAssessmentReviewStats,
});
//# sourceMappingURL=getAssessmentReviewStats.js.map